export default {
  FallbackIcon: () =>
    import(
      /* webpackChunkName: "FallbackIcon" */ '@/js/components/Shared/IconSelect/Icons/FallbackIcon.vue'
    ),
  DealerPortalLogo: () =>
    import(
      /* webpackChunkName: "DealerPortalLogo" */ '@/js/components/Shared/SvgSelect/SVG/DealerPortalLogo.vue'
    ),
  DPLogoBicycle: () =>
    import(
      /* webpackChunkName: "DPLogoBicycle" */ '@/js/components/Shared/SvgSelect/SVG/DPLogoBicycle.vue'
    ),
  DrawerStripes: () =>
    import(
      /* webpackChunkName: "DrawerStripes" */ '@/js/components/Shared/SvgSelect/SVG/DrawerStripes.vue'
    ),
  StripesBottomRight: () =>
    import(
      /* webpackChunkName: "StripesBottomRight" */ '@/js/components/Shared/SvgSelect/SVG/StripesBottomRight.vue'
    ),
  StripesTopLeft: () =>
    import(
      /* webpackChunkName: "StripesTopLeft" */ '@/js/components/Shared/SvgSelect/SVG/StripesTopLeft.vue'
    ),
  StripesTopLeftTransparent: () =>
    import(
      /* webpackChunkName: "StripesTopLeftTransparent" */ '@/js/components/Shared/SvgSelect/SVG/StripesTopLeftTransparent.vue'
    ),
}
